import { render, staticRenderFns } from "./Cube.vue?vue&type=template&id=7be95b89&scoped=true&"
import script from "./Cube.vue?vue&type=script&lang=js&"
export * from "./Cube.vue?vue&type=script&lang=js&"
import style0 from "./Cube.vue?vue&type=style&index=0&id=7be95b89&lang=scss&scoped=true&"
import style1 from "./Cube.vue?vue&type=style&index=1&id=7be95b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be95b89",
  null
  
)

export default component.exports